import React, { useState } from 'react';

import PropTypes from 'prop-types';

import LoanActionRunnerEngine from './components/LoanActionRunnerEngine';
import {
  DEFAULT_LOAN_ACTION_RUN_STATE,
  LoanActionRunnerStateContext,
} from './LoanActionRunnerProvider.constants';

/**
 * Hosts the shared loan-action run flow outside the loan header: runs `actionSource` items through
 * useLoanActionsControls with the injected executor / runner context and renders the run-flow
 * drawers. Children read the run state through useLoanActionRunnerContext. The run flow sits
 * beside `children` and only mounts while `isEnabled`, so enabling it never remounts the children.
 * A null `runnerContext` (not loaded yet) falls back to the loan-editor reads; hosts keep their
 * action disabled until their context is ready.
 */
const LoanActionRunnerProvider = ({
  children,
  actionSource,
  executor,
  isEnabled = true,
  runnerContext = null,
  onAfterExecute = null,
  onClientOnlyLaunch = null,
}) => {
  const [runState, setRunState] = useState(DEFAULT_LOAN_ACTION_RUN_STATE);

  return (
    <LoanActionRunnerStateContext.Provider value={runState}>
      {isEnabled && (
        <LoanActionRunnerEngine
          actionSource={actionSource}
          executor={executor}
          runnerContext={runnerContext}
          onAfterExecute={onAfterExecute}
          onClientOnlyLaunch={onClientOnlyLaunch}
          onRunStateChange={setRunState}
        />
      )}
      {children}
    </LoanActionRunnerStateContext.Provider>
  );
};

LoanActionRunnerProvider.propTypes = {
  children: PropTypes.node.isRequired,
  actionSource: PropTypes.arrayOf(PropTypes.object).isRequired,
  executor: PropTypes.func.isRequired,
  isEnabled: PropTypes.bool,
  runnerContext: PropTypes.object,
  onAfterExecute: PropTypes.func,
  onClientOnlyLaunch: PropTypes.func,
};

export default LoanActionRunnerProvider;
